import PropTypes from "prop-types"

const KeyValueShape = {
  value: PropTypes.number.isRequired,
  key: PropTypes.string.isRequired,
}
export default KeyValueShape



// WEBPACK FOOTER //
// ./src/state/shapes/KeyValueShape.js